import NetworkService from '../services/network.service'

class CommonServiceApi {
    redisCache = async (companyId: any, module: any) => {
        try{
        let url = `api/common-service/redisrebuildcache`;
        let body = { companyId: companyId, moduleName: module };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    triggerAnnouncement = async (companyId: any) => {
        try{
        let url = `api/common-service/triggerannouncement`;
        let body = { companyId: companyId };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    esIndex = async (companyId: any, module: any) => {
        try{
        let url = `/api/common-service/esrebuildcache`;
        let body = { companyId: companyId, moduleName: module };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    deleteCustomer = async (id:any) => {
        try{
        let url = `api/common-service/customers/delete`;
        let body = { id: id };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    deleteTicket = async (id:any) => {
        try{
        let url = `api/common-service/tickets/delete`;
        let body = { id: id };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    deleteInvoice = async (id:any) => {
        try{
        let url = `api/common-service/invoices/delete`;
        let body = { id: id };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    deleteEstimate = async (id:any) => {
        try{
        let url = `api/common-service/estimates/delete`;
        let body = { id: id };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    move = async (params:any) => {
        try{
        let url = `api/common-service/move`;
        // let body = { params: par };
        let data = await NetworkService.put(url, params)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

    qbSync = async (companyId: any, entitySchema: any, entityIds:any, keys:any) => {
        try{
        let url = `/api/common-service/qbsync`;
        let body = { companyId: companyId, entitySchema: entitySchema, entityIds: entityIds, keysToUpdate: keys };
        let data = await NetworkService.put(url, body)
        return data && data.data
            ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
    }

     updateSettings = async (params: any, collection: any) => {
        try {
            const { companyId } = params;
            const url = `/api/settings/${collection}/${companyId}`;
            const data = await NetworkService.put(url, params);
            return data && data.data ? data.data : data;
        } catch (err: any) {
            throw err;
        }
    };

    fetchStaticObjectData = async (staticObjectName = '') => {
        try {
        let url = `api/common-service/fetchstaticdata`;
        let config = {
            params: {
              staticObjectName
            }
          }
        let data = await NetworkService.get(url, config);
        return data && data.data
          ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
      }
    
    featureUpdating = async (body = {}) => {
        try {
            let url = `api/common-service/feature/update`;
            let config = body;
            let result = await NetworkService.put(url, config);
            return result;
        } catch (err: any) {
            throw err;
        }
    };

    getEnabledFeatures = async (body: { company: number }) => {
        try {
            let url = `api/common-service/enabled/features/list/${body.company}`;
            let config = {};
            let result = await NetworkService.get(url, config);
            return result;
        } catch (err: any) {
            throw err;
        }
    };

    fetchFeaturesMetaData = async () => {
        try {
            let url = `api/common-service/features/meta/data`;
            let config = {};
            let result = await NetworkService.get(url, config);
            return result;
        } catch (err: any) {
            throw err;
        }
    };

      fetchFpForms = async (staticObjectName = '') => {
        try {
        let url = `api/common-service/fetchfpForms`;
        let config = {
            params: {
              staticObjectName
            }
          }
        let data = await NetworkService.get(url, config);
        return data && data.data
          ? data.data : data
        }catch(err: any){
            return err.description? err.description : err;
        }
      }

    rebuildUpdatedSettingsRedisCache = async (
        settingsUpdatedList: string[],
        companyId: number
    ) => {
        try {
            let url = `api/common-service/features/settings/cache/rebuild`;
            let config = {
                settingsUpdatedList,
                companyId
            };
            let result = await NetworkService.post(url, config);
            return result;
        } catch (err: any) {
            throw err;
        }
    };

    searchUsers = async (searchQuery: string = '') => {
        try {
            let url = `api/settings/searchUsers`;
            let config = {
                params: {
                    searchQuery: searchQuery
                }
            };
            let result = await NetworkService.get(url, config);
            return result && result.data ? result.data : result;
        } catch (err: any) {
            throw err;
        }
    };

    getUserPermissions = async (userId: number) => {
        try {
            let url = `api/settings/user`;
            let config = {
                params: {
                    userid: userId
                }
            };
            let result = await NetworkService.get(url, config);
            return result && result.data ? result.data[0] : result;
        } catch (err: any) {
            throw err;
        }
    };

    updateUserPermissions = async (userSettings: any) => {
        try {
            let url = `api/settings/user`;
            let result = await NetworkService.put(url, userSettings);
            return result && result.data ? result.data : result;
        } catch (err: any) {
            throw err;
        }
    };

    getCompanyPaymentTerms = async () => {
        try {
            let url = `api/common-service/company/paymentterms`;
            let result = await NetworkService.get(url, {});
            return result && result.data ? result.data : result;
        } catch (err: any) {
            throw err;
        }
    };

    addPaymentTermWithoutQB = async (paymentTerm: any) => {
        try {
            let url = `api/common-service/paymentterm/addwithoutqb`;
            let result = await NetworkService.post(url, paymentTerm);
            return result && result.data ? result.data : result;
        } catch (err: any) {
            throw err;
        }
    };

    updatePaymentTerm = async (paymentTerm: any) => {
        try {
            let url = `api/common-service/paymentterm/update`;
            let result = await NetworkService.put(url, paymentTerm);
            return result && result.data ? result.data : result;
        } catch (err: any) {
            throw err;
        }
    };

    getEntityCounters = async (companyId: string | number): Promise<any> => {
        try {
            const url = `api/common-service/counter/${companyId}`;
            const data = await NetworkService.get(url, {});
            return data && (data as any).data ? (data as any).data : data;
        } catch (err: any) {
            return err.description ? err.description : err;
        }
    };

    updateEntityCounter = async (params: {
        companyId: string | number;
        moduleName: string;
        counter: number;
    }): Promise<any> => {
        try {
            const url = `api/common-service/counter`;
            const data = await NetworkService.put(url, params);
            return data && (data as any).data ? (data as any).data : data;
        } catch (err: any) {
            throw err;
        }
    };

}
export default CommonServiceApi;
